import React, { useEffect, useState } from 'react';
import { Card, CardContent, Container, Paper, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import Page from '../../components/Page';
import { useLoadingContext } from '../../context/loadingContext';
import { MemberService } from '../../Services/member.service';

const MemberDetail = () => {
  const { id } = useParams();
  const [detail, setDetail] = useState();
  const { handleStartLoading, handleStopLoading } = useLoadingContext();

  useEffect(() => {
    (async () => {
      try {
        handleStartLoading();
        const data = await MemberService.GetMemberCardById(id);
        setDetail(data);
      } catch (e) {
        console.log(e.response.data);
      } finally {
        handleStopLoading();
      }
    })();
  }, [id]);

  return (
    <Page title="Create event">
      <Container>
        {detail && (
          <>
            <Card>
              <Stack direction={{ xs: 'column', sm: 'row' }}>
                <img
                  style={{ height: '100%', width: '400px' }}
                  src={`${process.env.REACT_APP_IMAGE}/${detail.image}`}
                  alt={detail.code}
                />
                <CardContent sx={{ width: '100%' }}>
                  <Typography color={'#A7202C'} variant={'h4'}>
                    {detail.code}
                  </Typography>
                  <Typography variant={'body2'} mt={'8px'}>
                    {detail.description}
                  </Typography>
                </CardContent>
              </Stack>
            </Card>
            <Card sx={{ mt: '16px' }}>
              <CardContent>
                <Typography variant={'h4'}>Chi tiết ưu đãi</Typography>
                <ul>
                  {detail.gift.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </>
        )}
      </Container>
    </Page>
  );
};

export default MemberDetail;
